<template>
  <div>
    <div :class="['tw-relative tw-w-full', contexto === 'item' ? 'carousel-seguirleiloeiro' : '']"
         :id="`carousel-${dados.lote_id}`"
         data-carousel="static">
      <div v-if="dados.fotos && dados.fotos[0]" class="tw-relative tw-overflow-hidden tw-w-full"
           :class="[visual, contexto === 'item' ? 'carousel-seguirleiloeiro' : '']">
        <div v-if="dados.fotos.length === 1" class="tw-duration-700 tw-ease-in-out tw-w-full">
          <img v-if="visualizacao === 'loteAberto'" title="Clique para ampliar" v-img
               :src="`${dados.fotos[0].nm_path_incompleto + dados.fotos[0].tamanho.thumb_grande}/${dados.fotos[0].nm_path}`"
               class="tw-object-cover tw-w-full tw-h-full tw-absolute tw-block tw-w-full -tw-translate-x-1/2 -tw-translate-y-1/2 tw-top-1/2 tw-left-1/2">
          <a v-else>
            <img @click="redirecionarParaDetalhes" :src="dados.fotos[0].nm_path_completo"
                 class="tw-object-cover tw-w-full tw-h-full tw-absolute tw-block tw-cursor-pointer -tw-translate-x-1/2 -tw-translate-y-1/2 tw-top-1/2 tw-left-1/2"
                 :class="contexto === 'item' ? 'imagem-seguirleiloeiro' : ''"
            >
          </a>
        </div>
        <div v-else v-for="(img, index) in dados.fotos" :id="`carousel-item-${dados.lote_id}-${index}`"
             class="tw-duration-700 tw-ease-in-out tw-w-full" data-carousel-item>
          <img v-if="visualizacao === 'loteAberto'" v-img:group
               :src="`${img.nm_path_incompleto + img.tamanho.thumb_grande}/${img.nm_path}`"
               class="tw-object-cover tw-w-full tw-h-full tw-absolute tw-block tw-w-full -tw-translate-x-1/2 -tw-translate-y-1/2 tw-top-1/2 tw-left-1/2">
          <a v-else>
            <img @click="redirecionarParaDetalhes" :src="img.nm_path_completo"
                 class="tw-object-cover tw-w-full tw-h-full tw-absolute tw-block tw-cursor-pointer -tw-translate-x-1/2 -tw-translate-y-1/2 tw-top-1/2 tw-left-1/2"
                 :class="contexto === 'item' ? 'imagem-seguirleiloeiro' : ''"
            >
          </a>
        </div>
      </div>
      <div v-else class="tw-relative tw-overflow-hidden"
           :class="[visual, contexto === 'item' ? 'carousel-semfoto' : '']">
        <div :id="`carousel-item-${dados.lote_id}`"
             class="tw-duration-700 tw-ease-in-out tw-absolute tw-inset-0 tw-transition-transform -tw-transform tw-translate-x-full tw-z-10"
             data-carousel-item>
          <div v-if="visualizacao === 'loteAberto'">
            <img v-img :src="sourceImagem"
                 class="absolute block w-full -translate-x-1/2 -translate-y-1/2 top-1/2 -tw-left-1/2 right-1/2">
          </div>
          <div v-else>
            <img @click="redirecionarParaDetalhes"
                 :src="sourceImagem"
                 class="absolute block w-full tw-cursor-pointer -translate-x-1/2 -translate-y-1/2 top-1/2 -tw-left-1/2 right-1/2 imagem-sem-foto imagem-sem-foto-meireles"
                 :class="contexto === 'item' ? 'imagem-semfoto' : ''"
            >
          </div>
        </div>
      </div>
      <!-- Slider controls -->
      <div v-if="dados.fotos && dados.fotos.length > 1">
        <div
          class="tw-absolute tw-top-0 tw-start-0 tw-flex tw-items-center tw-justify-center tw-h-full tw-px-2 tw-cursor-pointer tw-group focus:tw-outline-none"
          data-carousel-prev>
          <button @click="onPrev"
                  class="tw-z-30 tw-inline-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-rounded-full tw-bg-white/50 group-hover:tw-bg-white/70 group-focus:tw-outline-none">
            <svg class="tw-w-3 tw-h-3 tw-text-white dark:tw-text-gray-800 rtl:tw-rotate-180 hover:tw-text-jrBlue-50"
                 aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M5 1 1 5l4 4"/>
            </svg>
          </button>
        </div>
        <div
          class="tw-absolute tw-top-0 tw-end-0 tw-flex tw-items-center tw-justify-center tw-h-full tw-px-2 tw-cursor-pointer tw-group focus:tw-outline-none"
          data-carousel-next>
          <button @click="onNext"
                  class="tw-z-30 tw-inline-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-rounded-full tw-bg-white/50 group-hover:tw-bg-white/70 group-focus:tw-outline-none">
            <svg class="tw-w-3 tw-h-3 tw-text-white dark:tw-text-gray-800 rtl:tw-rotate-180 hover:tw-text-jrBlue-50"
                 aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="m1 9 4-4-4-4"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {Carousel} from 'flowbite'

export default {
  props: [
    'dados',
    'visualizacao',
    'contexto'
  ],
  data() {
    return {
      carouselItem: null,
    }
  },
  created() {
    setTimeout(() => {

      if (this.dados.fotos && this.dados.fotos.length > 1)
        this.carousel()

    }, 1000)
  },
  methods: {
    carousel() {
      const carouselElement = document.getElementById(`carousel-${this.dados.lote_id}`);
      if (!carouselElement) return;

      const items = []
      const options = {
        defaultPosition: 0
      }

      if (this.dados.fotos) {
        const fotos = this.dados.fotos;
        fotos.map((img, index) => {
          const itemElement = document.getElementById('carousel-item-' + this.dados.lote_id + '-' + index);
          if (itemElement) {
            items.push({
              position: index,
              el: itemElement
            });
          }
        });
      } else {
        const itemElement = document.getElementById('carousel-item-' + this.dados.lote_id);
        if (itemElement) {
          items.push({
            position: 0,
            el: itemElement
          });
        }
      }

      if (items.length > 0) {
        this.carouselItem = new Carousel(carouselElement, items, options);
      }
    },
    onNext() {
      this.carouselItem.next();
    },
    onPrev() {
      this.carouselItem.prev();
    },
    slideTo(item) {
      this.carouselItem.slideTo(item)
    },
    redirecionarParaDetalhes() {
      window.location.href = `/leilao/index/leilao_id/${this.dados.leilao_id}/lote/${this.dados.lote_id}`;
    },
  },
  computed: {
    visual() {
      switch (this.visualizacao) {
        case 'card':
          return 'tw-rounded tw-h-44'
        case 'list':
          return 'tw-rounded tw-h-44'
        case 'loteAberto':
          return 'tw-rounded-lg md:tw-h-17 tw-h-72'
      }
    },
    sourceImagem() {
      return `https://906de634c48fb7d34136160b4c353ae4.s3.sa-east-1.amazonaws.com/public/${this.mainDomain}/layout/images/sem_foto.png`;
    },
    mainDomain() {
      if (typeof window === 'undefined') return '';

      const domainParts = window.location.hostname.split('.');

      if ((domainParts[0] === 'dev' || domainParts[0] === 'teste') && domainParts[1] !== 'vue') {
        return domainParts[1];
      }
      if (domainParts[0] === 'dev' && domainParts[1] === 'vue') {
        return domainParts[2];
      }
      if (domainParts[0] === 'www') {
        return domainParts[1];
      }

      return domainParts[0];
    },
  },
  mounted() {
    this.carousel();
  },
  updated() {
    this.carousel();
  }
}
</script>
<style scoped>
.top-1\/2 {
  top: 50%;
}

.w-full {
  width: 100%;
}

.block {
  display: block;
}

.hidden {
  display: none;
}

.left-1\/2 {
  left: 50%;
}

.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.-translate-x-1\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.-translate-y-1\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.duration-700 {
  transition-duration: 700ms;
}

.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.absolute {
  position: absolute;
}

.inset-0 {
  inset: 0px;
}

.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.z-10 {
  z-index: 10;
}

.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.z-20 {
  z-index: 20;
}

.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.carousel-seguirleiloeiro {
  height: 205px;
}

.imagem-seguirleiloeiro {
  border-radius: 10px;
}

.carousel-semfoto {
  overflow: visible !important;
}

.imagem-semfoto {
  --tw-translate-y: 0;
  height: 205px;
  object-fit: cover;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Carousel.vue